/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import moment from 'moment';
import { camelCase, cloneDeep, isEqual, uniqWith } from 'lodash';

import {
  SELECT_STATEMENTS_PREFIX,
  RECEIVED_DOCUMENT_REFERENCES,
  RECEIVED_CCPA_DOCUMENT_REFERENCES
} from 'state/statements/StatementsActions';

import {
  ALL_DOCUMENT_TYPES,
  STATEMENTS_DOC_SELECTION
} from 'state/statements/StatementsSelectors';

const currentYear = moment().year();

let timeOptions = [
  {
    label: currentYear,
    value: currentYear.toString()
  }
];

for (let i = 0; i < 7; i++) {
  const time = moment()
    .subtract(i + 1, 'years')
    .year()
    .toString();
  timeOptions.push({
    label: time,
    value: time
  });
}

export const initialStatementsFilterState = {
  timePeriod: {
    selection: currentYear.toString(),
    options: timeOptions
  },
  documentTypes: {
    selection: 'all',
    options: [
      {
        label: 'All',
        value: 'all'
      },
      {
        label: 'Statements',
        value: 'statement'
      },
      {
        label: 'Tax Forms',
        value: 'taxform'
      },
      {
        label: 'Confirmations',
        value: 'confirmation'
      },
      {
        label: 'Client Communications',
        value: 'clientcommunication'
      }
    ]
  },
  productTypes: {
    selection: 'all',
    options: [
      {
        label: 'All',
        value: 'all'
      },
      {
        label: 'Mutual Funds',
        value: 'mutualFund'
      },
      {
        label: 'ActivePlus Portfolios',
        value: 'activePlus'
      },
      {
        label: 'Brokerage',
        value: 'brokerage'
      },
      {
        label: '529 College Savings Plans',
        value: 'collegeSavings'
      }
    ]
  }
};

export const selectStatementsFilteringReducer = (
  state = cloneDeep(initialStatementsFilterState),
  action
) => {
  const { type, selection } = action;
  const isStatementsFilterSelection = type.startsWith(SELECT_STATEMENTS_PREFIX);

  if (type !== RECEIVED_DOCUMENT_REFERENCES && !isStatementsFilterSelection) {
    return state;
  }

  const statementsFilteringSelections = cloneDeep(state);
  const selectionType = camelCase(type.replace(SELECT_STATEMENTS_PREFIX, ''));

  if (selection) {
    statementsFilteringSelections[selectionType] = {
      selection,
      options: state[selectionType].options
    };
    if (selectionType === 'documentTypes') {
      if (
        selection &&
        (selection === ALL_DOCUMENT_TYPES ||
          selection === STATEMENTS_DOC_SELECTION)
      ) {
        statementsFilteringSelections.productTypes.selection =
          ALL_DOCUMENT_TYPES;
      }
    }
  }

  return statementsFilteringSelections;
};

export const statementComparator = (statementA, statementB) => {
  return isEqual(statementA, statementB);
};

export const statementsReducer = (state = [], action) => {
  if (action.type === RECEIVED_DOCUMENT_REFERENCES) {
    const { references } = action;
    return uniqWith([...state, ...references], statementComparator).sort(
      (a, b) => moment.utc(b.date).diff(moment.utc(a.date))
    );
  }

  if (action.type === RECEIVED_CCPA_DOCUMENT_REFERENCES) {
    const { references } = action;
    return uniqWith([...state, ...references], statementComparator);
  }

  return state;
};
